var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeImmutable, Money } from "../core";
import { CompositePackagingFeeRequirement, CustomParameterPackagingFeeRequirement, ExtraFeeId, Menu, ModifierItemPackagingFeeRequirement, PackagingFeeType, ProductCategoryPackagingFeeRequirement, ProductTypePackagingFeeRequirement, } from "../ordering";
import { singleton } from "tsyringe";
import { TranslatedParser } from "./TranslatedParser";
import { IdMap, RArray, RSet, toPairs } from "../collections";
let ExtraFeeTypeParser = class ExtraFeeTypeParser {
    constructor(translatedParser, menu) {
        this.translatedParser = translatedParser;
        this.menu = menu;
        makeImmutable(this);
    }
    parseExtraFee(id, extraFee) {
        switch (extraFee.tag) {
            case "PackagingFee":
                return new PackagingFeeType({
                    id: new ExtraFeeId(id),
                    name: this.translatedParser.parse(extraFee.name),
                    requirements: new CompositePackagingFeeRequirement(new RArray(extraFee.requirements).mapOptional((requirement) => this.parseRequirement(requirement))),
                    price: Money.fromBackend(extraFee.price),
                    deposit: extraFee.deposit,
                    addedAt: extraFee.addedAt,
                });
            default:
                return null;
        }
    }
    parseRequirement(requirement) {
        switch (requirement.tag) {
            case "IndicatedProducts":
                return new ProductTypePackagingFeeRequirement(RSet.fromIterable(new RArray(requirement.productIds).mapOptional((productId) => this.menu.productTypes.ids.rawFind(productId))));
            case "ProductsFromCategories":
                return new ProductCategoryPackagingFeeRequirement(RSet.fromIterable(new RArray(requirement.categoryIds).mapOptional((categoryId) => this.menu.productCategories.ids.rawFind(categoryId))));
            case "IndicatedCustomParameters": {
                const customParameterType = this.menu.customParameterTypes.rawFind(requirement.customParameterId);
                if (customParameterType === null) {
                    return null;
                }
                const customParameterChoiceIds = new RArray(requirement.customParameterChoiceIds).mapOptional((rawCustomParameterChoiceId) => customParameterType.choiceIds.rawFind(rawCustomParameterChoiceId));
                if (customParameterChoiceIds.isEmpty) {
                    return null;
                }
                return new CustomParameterPackagingFeeRequirement({
                    customParameterTypeId: customParameterType.id,
                    customParameterChoiceIds: RSet.fromIterable(customParameterChoiceIds),
                });
            }
            case "IndicatedModifierItems": {
                const modifierType = this.menu.modifierTypes.rawFind(requirement.modifierId);
                if (modifierType === null) {
                    return null;
                }
                const modifierItemTypeIds = new RArray(requirement.modifierItemIds).mapOptional((rawModifierItemTypeId) => modifierType.itemTypeIds.rawFind(rawModifierItemTypeId));
                if (modifierItemTypeIds.isEmpty) {
                    return null;
                }
                return new ModifierItemPackagingFeeRequirement({
                    modifierTypeId: modifierType.id,
                    modifierItemTypeIds: RSet.fromIterable(modifierItemTypeIds),
                });
            }
        }
    }
    parse(extraFees) {
        return IdMap.fromIterable(toPairs(extraFees).mapOptional(([extraFeeId, extraFee]) => this.parseExtraFee(extraFeeId, extraFee)));
    }
};
ExtraFeeTypeParser = __decorate([
    singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof TranslatedParser !== "undefined" && TranslatedParser) === "function" ? _a : Object, typeof (_b = typeof Menu !== "undefined" && Menu) === "function" ? _b : Object])
], ExtraFeeTypeParser);
export { ExtraFeeTypeParser };
